export const DLColors = {
    darkBlue : '#000667',
    lightBlack : '#2F2F2F',
    darkGreen : '#006400',    
    lightGray : '#b2b2b2',
    darkRed : '#8D0101'
}